import React from 'react';
import '../../styles/About.css';
import { Link } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';

export default function Secretariat() {
    // Top row - Secretary General (1 person)
    const secretaryGeneral = {
        id: 1,
        name: "Teresa Wankin",
        role: "Secretary General",
        subrole: "",
        image: process.env.PUBLIC_URL + '/assets/secretariat/Teresa_Wankin.JPG',
        link: 'https://www.linkedin.com/in/teresa-wankin-59a2b155/',
    };

    // Second row - Managers (4 people)
    const managers = [
        {
            id: 2,
            name: "Jimmy Rodrigues",
            role: "Finance and Administration Manager",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/secretariat/Jimmy_Rodrigues.JPG',
            link: 'https://www.linkedin.com/in/jimmy-rodrigues-2a61a73/',
        },
        {
            id: 3,
            name: "Lianne Dieffenthaller",
            role: "Operations & HR Manager",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/secretariat/Lianne_Dieffenthaller.jpg',
            link: 'https://www.linkedin.com/in/ldieffenthaller/',
        },
        {
            id: 4,
            name: "Nicole Freakley",
            role: "Business Development Manager",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/secretariat/Nicole_Freakley.JPG',
            link: 'https://www.linkedin.com/in/nicole-freakley-7a62b642/',
        },
        {
            id: 5,
            name: "Andrea Lewis-Francis",
            role: "Business Support Officer",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/secretariat/Andrea_Lewis-Francis.jpg',
            link: 'https://www.linkedin.com/in/andrea-lewis-francis-9990b158/',
        },
    ];

    // Third row - Officers (4 people)
    const officers = [
        {
            id: 6,
            name: "Jenelle Diaz",
            role: "Business Operations Officer",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/secretariat/Jenelle_Diaz.JPG',
            link: 'https://www.linkedin.com/in/jenelle-edwards/',
        },
        {
            id: 7,
            name: "Devika Flemming",
            role: "Business Support Officer",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/secretariat/Devika_Flemming.jpg',
            link: 'https://www.linkedin.com/in/devika-flemming/',
        },
        {
            id: 8,
            name: "Chrisal Martin",
            role: "Sales & Marketing Officer",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/secretariat/Chrisal_Martin.jpg',
            link: 'https://www.linkedin.com/in/chrisalmartin/',
        },
        {
            id: 9,
            name: "Samantha Ramoutar",
            role: "Executive Officer",
            subrole: "",
            image: process.env.PUBLIC_URL + '/assets/secretariat/Samantha_Ramoutar.jpg',
            link: '',
        }
    ];

    const renderMemberCard = (member) => {
        const hasLink = member.link && member.link.trim() !== '';
        const CardWrapper = hasLink ? Link : 'div';
        const cardProps = hasLink 
            ? { to: member.link, target: '_blank', className: 'board-member-card' }
            : { className: 'board-member-card' };

        return (
            <CardWrapper key={member.id} {...cardProps}>
                <div 
                    className='board-member-photo-new' 
                    style={{
                        backgroundImage: `url(${member.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                    }}
                />
                
                <div className='board-member-info'>
                    <div className='board-member-name'>
                        {member.name}
                        {hasLink && <FaLinkedin size={16} color='#0072b1' style={{marginLeft: '8px', flexShrink: 0}}/>}
                    </div>
                    <div className='board-member-role'>{member.role}</div>
                    {member.subrole && <div className='board-member-org'>{member.subrole}</div>}
                </div>
            </CardWrapper>
        );
    };

    return (
        <div className='board-page'>
            {/* Header Section */}
            <div className='board-hero'>
                <div className='board-hero-content'>
                    <h1 className='board-hero-title'>Meet Our Secretariat Staff</h1>
                    <p className='board-hero-subtitle'>CANTO TEAM</p>
                </div>
            </div>

            {/* Secretary General - Top of pyramid (1 person) */}
            <div className='board-section'>
                {/* <h2 className='board-section-title'>Secretary General</h2>
                <div className='board-section-divider'></div> */}
                <div className='board-grid secretariat-top-grid'>
                    {renderMemberCard(secretaryGeneral)}
                </div>
            </div>

            {/* Managers - Middle of pyramid (3 people) */}
            <div className='board-section'>
                {/* <h2 className='board-section-title'>Management</h2>
                <div className='board-section-divider'></div> */}
                <div className='board-grid secretariat-managers-grid'>
                    {managers.map(member => renderMemberCard(member))}
                </div>
            </div>

            {/* Officers - Bottom of pyramid (4 people) */}
            <div className='board-section directors-section'>
                {/* <h2 className='board-section-title'>Officers</h2>
                <div className='board-section-divider'></div> */}
                <div className='board-grid secretariat-officers-grid'>
                    {officers.map(member => renderMemberCard(member))}
                </div>
            </div>
        </div>
    );
}
